// Static grammar-criteria template text, resolved per grammar-eligible task type and locale.
//
// This is user-facing content — used verbatim as a LanguageUseScheme's criteria (solo or multi-member alike)
// (shown in the grading canvas and fed to the grammar-grading LLM prompt) — so it must match the exam's
// own content language, not a single hardcoded one. The actual text lives in
// localization/messages/*.json under "LanguageUseTemplates", resolved here via i18next with an explicit `lng`
// (never the ambient/browser locale) — callers resolve that `lng` themselves (see
// system-info.ts's resolveLngCode) from the exam's own conversation language.

import i18next from 'i18next';
import { TaskType } from '../task-types/task-main.js';

/** Namespace key under localization/messages/*.json's "LanguageUseTemplates" for each grammar-eligible task
 * type — mirrors the camelCase key convention task-main.ts already uses for these same types
 * (TaskTypeDescs.literaryAnalysisPoetry / analysisNonFiction / materialBasedEssay / essay). */
const GRAMMAR_TEMPLATE_KEY_BY_TASK_TYPE: Record<string, string> = {
  [TaskType.ESSAY]: 'essay',
  [TaskType.MATERIAL_BASED_ESSAY]: 'materialBasedEssay',
  [TaskType.LITERARY_ANALYSIS_POETRY]: 'literaryAnalysisPoetry',
  [TaskType.ANALYSIS_NON_FICTION]: 'analysisNonFiction',
};

/** The static grammar criteria text for a standalone (non-grouped) node of this task type, in `lng`. */
export function languageUseTemplateFor(taskType: string | undefined, lng: string): string {
  const key = taskType ? GRAMMAR_TEMPLATE_KEY_BY_TASK_TYPE[taskType] : undefined;
  if (!key) return '';
  return String(i18next.t(`LanguageUseTemplates.${key}`, { lng, defaultValue: '' }));
}

/** The generic, type-agnostic grammar criteria text used for a multi-task grammar GROUP whose members
 * don't all share one task type, in `lng`. */
export function genericLanguageUseGroupTemplate(lng: string): string {
  return String(i18next.t('LanguageUseTemplates.genericGroup', { lng, defaultValue: '' }));
}
